import script from "./uploadYyzz.vue?vue&type=script&setup=true&lang=ts"
export * from "./uploadYyzz.vue?vue&type=script&setup=true&lang=ts"

import "./uploadYyzz.vue?vue&type=style&index=0&id=12e534f9&lang=scss"
import "./uploadYyzz.vue?vue&type=style&index=1&id=12e534f9&lang=scss&scoped=true"

import exportComponent from "/data/.jenkins/workspace/Shita-erp-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12e534f9"]])

export default __exports__